import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ActionButtonProps {
  icon: LucideIcon;
  label: string;
  variant: "accept" | "reject";
  onClick: (e: React.MouseEvent) => void;
  className?: string;
}

export function ActionButton({ 
  icon: Icon, 
  label, 
  variant, 
  onClick, 
  className 
}: ActionButtonProps) {
  const isAccept = variant === "accept";
  
  return (
    <Button
      size="sm"
      onClick={onClick}
      className={cn(
        "group relative overflow-hidden h-9 px-4",
        "flex items-center justify-center self-center",
        "shadow-sm",
        isAccept 
          ? "bg-green-500/80 hover:bg-green-600/90 text-white" 
          : "bg-red-500/80 hover:bg-red-600/90 text-white",
        className
      )}
    >
      <span className="w-20 translate-x-1 transition-opacity duration-500 group-hover:opacity-0 text-sm font-medium">
        {label}
      </span>
      <i className={cn(
        "absolute inset-0 z-10 grid w-1/4 place-items-center transition-all duration-500 group-hover:w-full",
        isAccept 
          ? "bg-green-600/30" 
          : "bg-red-600/30"
      )}>
        <Icon
          className="opacity-90"
          size={16}
          strokeWidth={2.5}
          aria-hidden="true"
        />
      </i>
    </Button>
  );
}
